// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "cb51bb824fc6dbb1cbbe" + ".chunk.js";
};